var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHousetax({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 19,
    viewBox: "0 0 24 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 17.5004H21V8.83317C21 8.62557 20.957 8.42022 20.8735 8.23013C20.7901 8.04003 20.6681 7.86932 20.5153 7.7288L13.0153 0.652546C13.0116 0.649348 13.0082 0.645902 13.005 0.642234C12.7289 0.391109 12.369 0.251953 11.9958 0.251953C11.6225 0.251953 11.2627 0.391109 10.9866 0.642234L10.9762 0.652546L3.48469 7.7288C3.33187 7.86932 3.20989 8.04003 3.12646 8.23013C3.04303 8.42022 2.99997 8.62557 3 8.83317V17.5004H1.5C1.30109 17.5004 1.11032 17.5794 0.96967 17.72C0.829018 17.8607 0.75 18.0514 0.75 18.2504C0.75 18.4493 0.829018 18.64 0.96967 18.7807C1.11032 18.9213 1.30109 19.0004 1.5 19.0004H22.5C22.6989 19.0004 22.8897 18.9213 23.0303 18.7807C23.171 18.64 23.25 18.4493 23.25 18.2504C23.25 18.0514 23.171 17.8607 23.0303 17.72C22.8897 17.5794 22.6989 17.5004 22.5 17.5004ZM4.5 8.83317L4.51031 8.8238L12 1.75036L19.4906 8.82192L19.5009 8.8313V17.5004H15V13.0004C15 12.6025 14.842 12.221 14.5607 11.9397C14.2794 11.6584 13.8978 11.5004 13.5 11.5004H10.5C10.1022 11.5004 9.72064 11.6584 9.43934 11.9397C9.15804 12.221 9 12.6025 9 13.0004V17.5004H4.5V8.83317ZM13.5 17.5004H10.5V13.0004H13.5V17.5004Z",
    fill: "#3D505E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHousetax);
export default __webpack_public_path__ + "static/media/house tax.300fa86f157705d4f2e57a7dd4784fc5.svg";
export { ForwardRef as ReactComponent };